import { render, staticRenderFns } from "./ViewPerson.vue?vue&type=template&id=01262829&scoped=true"
import script from "./ViewPerson.vue?vue&type=script&lang=js"
export * from "./ViewPerson.vue?vue&type=script&lang=js"
import style0 from "./ViewPerson.vue?vue&type=style&index=0&id=01262829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01262829",
  null
  
)

export default component.exports